import { notification } from 'antd';
import React, { useEffect } from 'react';
import { CSSProperties } from 'react';
import { GET } from '../../utils/apiCalls';
import { useNavigate, useParams } from 'react-router-dom';

const Failed = () => {

  const { tid } = useParams();

  useEffect(() => {
    if(tid){
      finalizeSubscription();
    }
  }, []);

  const finalizeSubscription = async () => {
    if (!tid) {
      notification.error({
        message: "Missing Transaction ID",
        description: "Transaction ID is required to finalize subscription.",
        duration: 4,
      });
      return;
    }
  
    try {
      await GET(`ease-buzz-payment/failed/${tid}`,null);
      notification.success({
        message: "Payment Failed",
        description: "Your subscription payment failed. Please try again.",
        duration: 3,
      });
  
    } catch (error: any) {
      console.error("Subscription error:", error);
      notification.error({
        message: "Payment Failed",
        description: error?.message || "Payment failed. Please contact support.",
        duration: 4,
      });
    }
  };

  const containerStyle: CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(160deg, #ff6b6b 0%, #4b79a1 100%)',
    padding: '20px',
    overflow: 'hidden'
  };

  const cardStyle: CSSProperties = {
    maxWidth: '450px',
    width: '100%',
    padding: '40px',
    borderRadius: '20px',
    background: 'rgba(255, 255, 255, 0.95)',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
    animation: 'fadeInUp 0.6s ease-out',
    position: 'relative',
    overflow: 'hidden'
  };

  const iconStyle: CSSProperties = {
    fontSize: '70px',
    color: '#ff3e3e',
    marginBottom: '25px',
    animation: 'pulse 1.5s infinite'
  };

  const titleStyle: CSSProperties = {
    fontSize: '28px',
    fontWeight: 700,
    color: '#2d2d2d',
    marginBottom: '15px',
    fontFamily: "'Poppins', sans-serif"
  };

  const messageStyle: CSSProperties = {
    fontSize: '16px',
    color: '#555',
    marginBottom: '30px',
    lineHeight: 1.5,
    fontFamily: "'Roboto', sans-serif"
  };

  const buttonStyle: CSSProperties = {
    padding: '12px 40px',
    fontSize: '17px',
    fontWeight: 600,
    borderRadius: '50px',
    border: 'none',
    background: 'linear-gradient(90deg, #ff3e3e 0%, #ff6b6b 100%)',
    color: 'white',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    boxShadow: '0 4px 15px rgba(255, 62, 62, 0.4)'
  };

  const buttonHoverStyle: CSSProperties = {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 20px rgba(255, 62, 62, 0.6)'
  };

  return (
    <div style={containerStyle} className="container">
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
        `}
      </style>
      <div style={cardStyle} className="card">
        <div style={iconStyle}>
          <i className="bi bi-exclamation-circle-fill"></i>
        </div>
        <h2 style={titleStyle}>Payment Failed</h2>
        <p style={messageStyle}>
          Oops! Something went wrong with your payment. Please verify your details or try a different payment method.
        </p>
        <button 
          style={buttonStyle} 
          className="btn"
          onMouseOver={(e) => Object.assign(e.target, buttonHoverStyle)}
          onMouseOut={(e) => Object.assign(e.target, buttonStyle)}
          onClick={() => window.location.href = '/CheckoutPage'}
        >
          Retry Payment
        </button>
      </div>
    </div>
  );
};

export default Failed;